import ErrorToast from "../../components/common/toasts/ErrorToast";
import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import DictionaryPanel from "./components/dictionaries/DictionaryPanel";
import AddDictionaryEntryPage from "./pages/dictionaries/AddDictionaryEntryPage";
import EditDictionaryEntryPage from "./pages/dictionaries/EditDictionaryEntryPage";
import { premiumPaths } from "./navigation";

/** Rodzaj słownika i edycja mają własne adresy, także po odświeżeniu strony. */
export default function Dictionaries({
  organization,
  token,
  admin = false,
  action = "list",
}) {
  const { dictionaryKind } = useParams();
  const definitions = organization.plugin?.dictionaries || [];
  if (!definitions.length)
    return (
      <section className="card premium-panel">
        Ta konfiguracja nie udostępnia słowników.
      </section>
    );
  if (!dictionaryKind)
    return (
      <Navigate
        to={premiumPaths.dictionary(
          organization.id,
          definitions[0].kind,
          admin,
        )}
        replace
      />
    );
  const definition = definitions.find((item) => item.kind === dictionaryKind);
  if (!definition)
    return (
      <section className="card premium-panel">
        <ErrorToast message="Nie znaleziono słownika w konfiguracji firmy." />
        <Link to={premiumPaths.dictionaries(organization.id, admin)}>
          Wróć do słowników
        </Link>
      </section>
    );
  const listPath = premiumPaths.dictionary(
    organization.id,
    definition.kind,
    admin,
  );
  const EntryPage =
    action === "edit" ? EditDictionaryEntryPage : AddDictionaryEntryPage;
  return action === "list" ? (
    <DictionaryPanel
      key={listPath}
      organization={organization}
      token={token}
      definition={definition}
      definitions={definitions}
      admin={admin}
    />
  ) : (
    <EntryPage
      key={`${listPath}:${action}`}
      organization={organization}
      token={token}
      definition={definition}
      listPath={listPath}
    />
  );
}
